module.exports = __webpack_public_path__ + "static/media/sideMatBlue10.e6f91572.png";